import Icon from '../components/Icon.vue'

Icon.register({
  'folder-open': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M572.7 292.1l-72.4 124.2c-10.2 17.5-35 31.8-55.3 31.8h0-400c-18.5 0-30.1-20.1-20.7-36.1l72.4-124.2c10.2-17.5 35-31.8 55.3-31.8v0h400c18.5 0 30.1 20.1 20.7 36.1zM152 224c-34 0-65.8 18.3-82.9 47.6l-69.1 118.4v-278c0-26.5 21.5-48 48-48h160l64 64h160c26.5 0 48 21.5 48 48v48h-328z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/folder-open.js
// module id = 1367
// module chunks = 0